import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Flickity from 'flickity';
import '../css/flickity.min.css';

export default class FlickitySlider extends Component{
  constructor(props) {
    super(props);

    this.state = {
      flickityReady: false,
    };

    this.refreshFlickity = this.refreshFlickity.bind(this);
  }

  componentDidMount() {
    this.flickity = new Flickity(this.flickityNode, this.props.options || {});

    this.setState({
      flickityReady: true,
    });
  }

  refreshFlickity() {
    this.flickity.reloadCells();
    this.flickity.resize();
    this.flickity.updateDraggable();
  }

  componentWillUnmount() {
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const flickityDidBecomeActive = !prevState.flickityReady && this.state.flickityReady;
    const previousChildren = React.Children.count(prevProps.children);
    const currentChildren = React.Children.count(this.props.children);
    const childrenDidChange = previousChildren !== currentChildren;

    if (this.flickity && (flickityDidBecomeActive || childrenDidChange)) {
      this.refreshFlickity();
    }
  }

  renderPortal() {
    if (!this.flickityNode) {
      return null;
    }

    const mountNode = this.flickityNode.querySelector('.flickity-slider');

    if (mountNode) {
      return ReactDOM.createPortal(this.props.children, mountNode);
    }
  }

  render() {
    return [
      <div className={'carousel'} key="flickityBase" ref={node => (this.flickityNode = node)} />,
      this.renderPortal(),
    ].filter(Boolean);
  }
}
